import { ChangeEvent } from 'react'

interface ISelectProps{
    value:  string | number
    data: any[]
    onChange: (changeValue: string)=>void
}

export default function Select({value, data, onChange=()=>{}}:ISelectProps) {

    const handleOnChange = (e:ChangeEvent<HTMLSelectElement>)=>{
        onChange(e.currentTarget.value)
    }
    
  return (
    <select
        value={value}
        onChange={handleOnChange}
        className="bg-primary text-secondary2 border rounded border-white/20 p-1 appearance-none outline-none"
    >
        {
            data?.map((dataItem, index)=>(
                <option key={index} value={dataItem.value}>{dataItem.value}</option>
            ))
        }
    </select>
  )
}
